export default "__VITE_ASSET__4bc81b50__"